import { render, staticRenderFns } from "./NoHeadTextInput.vue?vue&type=template&id=6ccd78f6"
import script from "./NoHeadTextInput.vue?vue&type=script&lang=js"
export * from "./NoHeadTextInput.vue?vue&type=script&lang=js"
import style0 from "./NoHeadTextInput.vue?vue&type=style&index=0&id=6ccd78f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports